module.exports = __webpack_public_path__ + "img/product2.0ab55d20.jpg";